// 定义静态路由，动态路由(后端接口返回)及处理在 `utils/routesFilter.js` 中
import msgRoute from './msg';
// import publicRoute from './public';
import productRoute from './product';
import demoRoute from './demo';
import cmsRoute from './cms';
import marketingRoute from './marketing';
import orderRoute from './order';
import librarysRoute from './librarys';
import serviceRoute from './onlineservice';
import settings from 'settings';
import memberRoute from './member';
import seoRoute from './seo';
import auditRoute from './audit';
import omoRoute from './omo';
import designRoute from './design';
import chatRoute from './chat';
import formRoute from './form';
import importRoute from './importPath';
import lowcodeRoute from './lowcode';
import thirdappRoute from './thirdapp.js';
import hospitalRoute from './hospital';
import media from './media';
import managePanelRoute from './managePanel';
// console.log(rootComponent, '@@@@@@@@@@@@@@@@@@@@@@@wcnma');
// const { rootComponent } = settings;

export const staticRoutes = [
    {
        path: '/login',
        component: () => import('views/layouts/login/index'),
        meta: {
            title: '登录',
        },
    },
    {
        path: '/design/nrecyce',
        component: () => import('views/modules/np/recycle/index'),
        meta: {
            title: '设计器专用回收站',
        },
    },
    {
        path: '/tool',
        component: () => import('views/layouts/login/tool'),
        meta: {
            title: '产品迁移工具',
        },
    },
    {
        path: '/dev-third-tool',
        component: () => import('views/layouts/login/micro'),
        meta: {
            title: '三方接入工具',
        },
    },   
    {
        path: '/shoptool',
        component: () => import('views/layouts/login/shoptool'),
        meta: {
            title: '全网商城1.5迁移工具',
        },
    },
    ...omoRoute,
    {
        path: '/privateSite/list',
        name: 'privateSite',
        component: () => import('views/modules/privateSite/list'),
        meta: {
            parent: '',
            parentId: 0,
            path: false,
            icon: 'fa fa-dashboard',
            title: '站群列表',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: true,
            isHide: false,
        },
        children: [],
    },
    {
        path: '/ip-lib',
        component: () => import('views/operate-tools/ip-lib/index.vue'),
        meta: {
            title: 'IP库维护',
        },
    },
    {
        path: '/404',
        name: 'notFound',
        component: () => import('views/layouts/error/404'),
        meta: {
            title: '找不到此页面',
        },
    },
    {
        path: '/401',
        name: 'noPower',
        component: () => import('views/layouts/error/401'),
        meta: {
            title: '没有权限',
        },
    },
    {
        path: '/999',
        name: 'noLogin',
        component: () => import('views/layouts/error/999'),
        meta: {
            title: '没有登录',
        },
    },
    {
        // 带有整体菜单 不受权限控制，注意使用的安全性
        path: '/static',
        // component: views[`../../views/layouts/default/index.vue`],
        component: () => import('../../views/layouts/default/index.vue'),
        // demoRoute 里面的路径如: path: '/static/**' 参数通过如: /static/**/:appId/:otherId
        children: [...productRoute, ...demoRoute, ...cmsRoute, ...marketingRoute, ...serviceRoute, ...orderRoute, ...seoRoute, ...memberRoute, ...auditRoute, ...chatRoute, ...formRoute, ...importRoute,...thirdappRoute, ...hospitalRoute, ...media],
    },
    // ...formRoute,
    ...lowcodeRoute,
    ...msgRoute, // 不需要菜单
    ...librarysRoute, // 不需要菜单
    ...designRoute,
    ...omoRoute,
    ...managePanelRoute,
    {
        path: '/static/translate/dict',
        name: 'translate-dict',
        component: () => import('views/modules/setting/translate/translateDict'),
        meta: {
            title: '翻译词典', 
        },
    },

    // {
    //     // 不带有菜单 不受权限控制，注意使用的安全性
    //     path: '/public',
    //     component: () => import('views/' + nodeComponent),
    //     children: [...publicRoute],
    // },
    // ...publicRoute, // 对外开放路由
];

// 定义404界面
export const pathMatch = {
    path: '/:path(.*)*',
    redirect: '/404',
};
